import { ParametrosDeBusca } from './../../common/types/Busca'
import axios from '@/plugins/axios'

export default class GenericService<ReturnType, InputType, PostType = InputType> {
	axios: typeof axios
	route: string

	constructor(route: string) {
		this.route = route
		this.axios = axios
	}

	async find(params: ParametrosDeBusca = {}): Promise<ReturnType[]> {
		const result = await this.axios.get<ReturnType[]>(this.route, {
			params,
		})
		return result.data
	}

	async get(id: string) {
		const result = await this.axios.get<ReturnType>(`${this.route}/${id}`)
		return result.data
	}

	async put(id: string, input: InputType) {
		const result = await this.axios.put<ReturnType>(`${this.route}/${id}`, input)
		return result.data
	}

	async patch(id: string, input: Partial<InputType>) {
		const result = await this.axios.patch<ReturnType>(`${this.route}/${id}`, input)
		return result.data
	}

	async post(input: PostType) {
		const result = await this.axios.post<ReturnType>(`${this.route}`, input)
		return result.data
	}

	async remove(id: string) {
		const result = await this.axios.delete<ReturnType>(`${this.route}/${id}`)
		return result.data
	}
}
